// extracted by mini-css-extract-plugin
export default {"title":"V6ctudTM9UEJJQFnX5SM"};